import { getRecordDefinition } from "./recordDefinitions";
import { RelatedTableActions } from "./relatedTableActions.types";

/** The actions for one related table on one page, from that page's definition, or none. */
export function getRelatedTableActions(
  parentEntityName: string | undefined,
  relatedEntityName: string
): RelatedTableActions | undefined {
  return parentEntityName
    ? getRecordDefinition(parentEntityName)?.relatedTableActions?.[
        relatedEntityName
      ]
    : undefined;
}
